import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../icon/types';

export const EeIcon = (props: IconProps) => (
  <ChakraIcon
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 480"
    {...props}
  >
    <g fillRule="evenodd" strokeWidth="1pt">
      <rect width={640} height={477.9} fill="#000001" rx={0} ry={0} />
      <rect width={640} height={159.3} y={320.7} fill="#fff" rx={0} ry={0} />
      <path fill="#1791ff" d="M0 0h640v159.3H0z" />
    </g>
  </ChakraIcon>
);
